import { Component, OnInit } from '@angular/core';
import { RoleService } from './../../services/role.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.css']
})
export class TopNavComponent implements OnInit {
  isCollapsede: boolean = true;
  user_id: any = 0;
  company_id: any = 0;
  role_id: any = 0;
  APIKEY: any = 0;
  customers_per: boolean = false;
  soa_images_per: boolean = false;
  factoring_per: boolean = false;
  user_per: boolean = false;
  activity_per: boolean = false;
  company_setting_per: boolean = false;
  edit_profile_per: boolean = false;
  mobile_soa_images_per: boolean = false;
  logout_per: boolean = false;

  role_type: any = '';
  currentUserRole: any = '';
  abc: any = [];

  report_per: boolean = false;
  professional_per: boolean;
  ccc_service: boolean;

  constructor(private _role: RoleService, private _router: Router,) { }

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.role_id = localStorage.getItem('role_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this.abc = localStorage.getItem('currentUser');
    var obj = JSON.parse(this.abc);
    this.currentUserRole = localStorage.getItem('role_name'); //obj.role_name;

    const data = {
      APIKEY: this.APIKEY,
      user: this.user_id,
      role_id: this.role_id,
      company_id: this.company_id
    };

    if (this.role_id == 1 || this.role_id == 2 || this.role_id == 3) {
    }
    else {
      this._role.getRolePer(data).subscribe(
        res => {
          this.role_type = res.data[0].role_name;
          if ((res.data[0].role_name) != 'Professional User') {
            if (res.data[0].module_name == 'Customers' && res.data[0].checked == 1) {
              this.customers_per = true;
            }
            if (res.data[1].module_name == 'SOA_Images' && res.data[1].checked == 1) {
              this.soa_images_per = true;
            }
            if (res.data[2].module_name == 'Factoring' && res.data[2].checked == 1) {
              this.factoring_per = true;
            }
            if (res.data[3].module_name == 'User' && res.data[3].checked == 1) {
              this.user_per = true;
            }
            if (res.data[4].module_name == 'Activity' && res.data[4].checked == 1) {
              this.activity_per = true;
            }
            if (res.data[5].module_name == 'Company_Setting' && res.data[5].checked == 1) {
              this.company_setting_per = true;
            }

            //if(res.data[5].module_name=='Company_Setting' && res.data[5].checked==1){
            this.report_per = true;
            this.professional_per = true;
            this.ccc_service = true;
            //}

          }
          else {
            this.edit_profile_per = true;
            this.ccc_service = true;
            this.professional_per = true;
            //if (res.data[0].module_name == 'SOA_Images' && res.data[0].checked == 1) {
            this.mobile_soa_images_per = true;
            //}
            this.logout_per = true;
          }
        },
      );
    }

    if (this.role_id == 1 || this.role_id == 2) {
      this.soa_images_per = true;
      this.company_setting_per = true;
      this.activity_per = true;
      this.factoring_per = true;
      this.user_per = true;
      this.customers_per = true;
    }
    else if (this.role_id == 3) {
      this.soa_images_per = false;
      this.company_setting_per = false;
      this.activity_per = false;
      this.factoring_per = false;
      this.user_per = false;
      this.customers_per = false;
    }
  }

  redirectPage(url) {
    //this._router.navigate(["/super-admin/customer-list/active"]);
    this._router.navigateByUrl('/redirect').then(() => {
      this._router.navigate([url]);
    });
  }

}